import { RouterProvider } from "react-router-dom"
import { router } from "./router.jsx";
import ErrorModal from './Components/ErrorModal/ErrorModal.jsx';
import InternetStatusModal from "./InternetConnection.jsx";
import TransactionExpiredModal from "./Components/TransactionExpired/TransactionExpiredModal.jsx";


const App = () => {

  return (
    <div>
      <ErrorModal />
      <InternetStatusModal />
      <TransactionExpiredModal />
      <div className="app-wrapper">
        <RouterProvider router={router()} />
      </div>
    </div>
  );
};

export default App;